import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Pages, {
  GridPage, Home,
  ButtonPage,
  DropdownPage,
  ModalPage,
  IconsPage,
  AccordionPage,
  ToastPage,
  AboutPage,
  NotFoundPage,
  CardBigTextPage,
  LoaderPage,
  ComponentsPage,
  CodePage,
  InputPage,
  NavbarPage,
  MenuDemoPage,
  ToggleMenuDemoPage,
  TableSortSearchPage,
  CardDemoPage,
  UQDataGridDemoPage,
  ChartsDemoPage,
  StatisticCard,
  UQLabelPage,
  BreadcrumbDemoPage,
  DividerDemoPage,
  CheckboxDemoPage,
  SpacerDemoPage,
  ProgressBarDemoPage,
  FileReadDemoPage,
  TooltipPage,
} from "./pages";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Pages />}>
          <Route index element={<Home />} />
          <Route path="/components" element={<ComponentsPage />} />
          <Route path="components/navbar" element={<NavbarPage />} />
          <Route path="components/button" element={<ButtonPage />} />
          <Route path="components/input" element={<InputPage />} />
          <Route path="components/dropdown" element={<DropdownPage />} />
          <Route path="components/menu" element={<MenuDemoPage />} />
          <Route path="components/data-grid" element={<UQDataGridDemoPage />} />
          <Route path="components/table-sort-search" element={<TableSortSearchPage />} />
          <Route path="components/togglemenu" element={<ToggleMenuDemoPage />} />
          <Route path="components/modal" element={<ModalPage />} />
          <Route path="components/card" element={<CardDemoPage />} />
          <Route path="components/statistic-card" element={<StatisticCard />} />
          <Route path="components/label" element={<UQLabelPage />} />
          <Route path="components/card-big-text" element={<CardBigTextPage />} />
          <Route path="components/accordion" element={<AccordionPage />} />
          <Route path="components/charts" element={<ChartsDemoPage />} />
          <Route path="components/file-read" element={<FileReadDemoPage />} />
          <Route path="components/grid" element={<GridPage />} />
          <Route path="components/icons" element={<IconsPage />} />
          <Route path="components/toast" element={<ToastPage />} />
          <Route path="components/loader" element={<LoaderPage />} />
          <Route path="components/code" element={<CodePage />} />
          <Route path="components/breadcrumb" element={<BreadcrumbDemoPage />} />
          <Route path="components/divider" element={<DividerDemoPage />} />
          <Route path="components/checkbox" element={<CheckboxDemoPage />} />
          <Route path="components/spacer" element={<SpacerDemoPage />} />
          <Route path="components/progress-bar" element={<ProgressBarDemoPage />} />
          <Route path="components/tooltip" element={<TooltipPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;